// ============================================================================
// page-service / testimonial.js
// ----------------------------------------------------------------------------
// Testimonial slider — left-aligned Flickity with external prev/next arrows
// in .services-testimonial__slider-nav.{prev,next}.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".services-testimonial__slider");
  if (!sliderEl) return;

  sliderEl.style.display = "block";

  const instances = initCarousels(".services-testimonial__slider", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  const prev = document.querySelector(".services-testimonial__slider-nav.prev");
  const next = document.querySelector(".services-testimonial__slider-nav.next");
  if (prev)
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      flkty.next();
    });
});
